import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TokenService } from "../auth/token.service";

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(private tokenService: TokenService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenService.retornaToken();

    // URLs que não precisam de token (endpoints públicos)
    const excludedUrls = [
      '/user/authenticate',
      '/user/register',
      '/user/emailValidate',
      '/user/send-email-verification',
      '/password-recovery',
      '/password-change'
    ];
 
    const isExcluded = excludedUrls.some(url => req.url.includes(url));
    
    if (token && !isExcluded) {

      
      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      return next.handle(clonedReq);
    } 

    return next.handle(req);
  }
}
